import React from 'react';
import Hero from '../../components/ui/Hero';
import Introduction from '../../components/evolution/sections/Introduction';
import AutomataToAnimatronics from '../../components/evolution/sections/AutomataToAnimatronics';
import AnimatronicsInFilm from '../../components/evolution/sections/AnimatronicsInFilm';
import Timeline from '../../components/evolution/sections/Timeline';
import Competition from '../../components/evolution/sections/Competition';
import PhysicalAnimatronics from '../../components/evolution/sections/PhysicalAnimatronics';
import Technology from '../../components/evolution/sections/Technology';
import Future from '../../components/evolution/sections/Future';
import CallToAction from '../../components/evolution/CallToAction';
import References from '../../components/evolution/sections/References';
import ScrollReveal from '../../components/ui/ScrollReveal';

const EvolutionPage = () => {
  const heroImage = "https://nifmkzddenyukgjcdetc.supabase.co/storage/v1/object/public/animatronics_data/logo_light.webp?t=2024-12-30T20%3A06%3A02.198Z";

  return (
    <div className="min-h-screen bg-background">
      <Hero
        title="Evolution of Animatronics"
        description="From Simple Mechanisms to Modern Marvels"
        backgroundImage={heroImage}
        compact
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-24">
          <ScrollReveal>
            <Introduction />
          </ScrollReveal>

          <ScrollReveal>
            <AutomataToAnimatronics />
          </ScrollReveal>

          <ScrollReveal>
            <AnimatronicsInFilm />
          </ScrollReveal>

          <ScrollReveal>
            <Timeline />
          </ScrollReveal>

          <ScrollReveal>
            <Competition />
          </ScrollReveal>

          <ScrollReveal>
            <PhysicalAnimatronics />
          </ScrollReveal>

          <ScrollReveal>
            <Technology />
          </ScrollReveal>

          <ScrollReveal>
            <Future />
          </ScrollReveal>

          <ScrollReveal>
            <CallToAction />
          </ScrollReveal>

          <ScrollReveal>
            <References />
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
};

export default EvolutionPage;